module.exports = __webpack_public_path__ + "img/music-white.83ba5215.svg";